// extracted by mini-css-extract-plugin
export default {"Textbox":"KaOEocpW"};